import { Grid, Typography  } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";

export default function FeatureIcons() {

  const lastestServices = [
    {
      icon: "assets/svg/fill.svg",
      title: "It's Simple",
      description: "Easy to use interface for quick access to medical information",
      colorClass: "text-orange",
      bgColor: "var(--radium-info-600)", 
      iconBg: "var(--radium-info-600)" ,
    },
    {
      icon: "assets/svg/secure.svg", 
      title: "It's Secure",
      description: "Bank-level encryption protects your sensitive health data",
      colorClass: "text-sky-blue",
      bgColor: "var(--blue-color-400)",
      iconBg: "var(--blue-color-400)"
    },
    {
      icon: "assets/svg/call.svg",
      title: "On Call 24/7",
      description: "Round-the-clock support when you need it most",
      colorClass: "text-green",
      bgColor: "var(--radium-info-600)", 
      iconBg: "var(--radium-info-600)" ,// Darker red for wavy edge
    },
    {
      icon: "assets/svg/card.svg",
      title: "Affordable",
      description: "Cost-effective solution for comprehensive health management",
      colorClass: "text-gray",
     bgColor: "var(--blue-color-400)",
      iconBg: "var(--blue-color-400)"
    }
  ]
  const latestItems = [
    {
      bg: "bg-dark-blue",
      images: ["assets/images/insight.png", "assets/images/travelParkImg.png"],
      condition: "even",
    },
    {
      bg: "bg-ency-600",
      images: ["assets/images/clsion.png"],
      text: "HealthyHabits Announces Partnership with FootprintID® The partnership will revolutionize employer-backed wellness benefits",
      condition: "odd",
    },
    {
      bg: "bg-gray",
      images: ["assets/images/travelPark.png", "assets/images/insightImg.png"],
      condition: "even",
    },
    {
      bg: "bg-ency-600",
      images: ["assets/images/ipmim.png"],
      text: "Generali Global Assistance Has Selected FootprintID® To Enhance Trip Mate Travel Protection Plans.",
      condition: "odd",
    },
  ];

  const articleItems = [
  {
    title: "Generali global assistance has selected FootprintID® to enhance trip mate travel protection plans",
    borderColor: "border-top-orange",
    description: "This partnership provides travelers with secure access to personal portable medical records when traveling",
    link: "https://us.generaliglobalassistance.com/press/press-releases/generali-global-assistance-selected-footprintid-enhance-trip-mate-travel-protection-plans/",
  
  },
  {
    title: "FootprintID®: “your entire health history is available at your fingertips”",
    borderColor: "border-top-sky-blue",
    description: "Health Tech World hears from the co-founder and president of FootprintID®, Beth Tofel, about the platform’s mission to save the lives of business travelers and help organisations fulfill their duty of care.",
    link: "https://www.htworld.co.uk/leadership/interviews/footprintid-your-entire-health-history-is-available-at-your-fingertips/",
  },
  {
    borderColor: "border-top-green",
    title: "How Better Sensors Could Make the New Apple Watch Great",
    description: "Enhanced sensors can help in detecting early signs of health issues that might otherwise go unnoticed, like irregular heart rhythms or drops in oxygen levels, Beth Tofel, the president of FootprintID®, a medical information tracking company, said via email.",
    link: "https://www.yahoo.com/lifestyle/better-sensors-could-apple-watch-143632603.html",
  },
  {
    borderColor: "border-top-black",
    title: "Travel Insurance Companies Are Upgrading Their Policies. Here’s What’s New",
    description: "World Nomads added a feature called FootprintID®, an app that allows travelers to securely store their medical records including allergies, medications and emergency contact information, which they can then easily share with first responders, healthcare providers and family in an emergency",
    link: "https://www.forbes.com/sites/christopherelliott/2023/08/12/travel-insurance-companies-are-upgrading-their-policies-heres-whats-new/",
  },
  {
    borderColor: "border-top-sky-yellow",
    title: "Beth Tofel On The Five Things You Can Do To Become More Resilient During Turbulent Times",
    description: "As part of my series about 'developments in the travel industry over the next five years', I had the pleasure of interviewing Beth Tofel of FootprintID. … Between raising her own children and helping to enhance the lives of children in the community, FootprintID®'s President and Co-Founder has been on the frontlines when it comes to knowing what parents need and want to increase their peace of mind.",
    link: "https://community.thriveglobal.com/beth-tofel-on-the-five-things-you-can-do-to-become-more-resilient-during-turbulent-times/",
    cardLink:[
      {link: "https://community.thriveglobal.com/beth-tofel-on-the-five-things-you-can-do-to-become-more-resilient-during-turbulent-times/", text: "… www.facebook.com/footprintid www.linkedin.com/bethtofel"},
      {link: "https://community.thriveglobal.com/beth-tofel-on-the-five-things-you-can-do-to-become-more-resilient-during-turbulent-times/", text: "www.linkedin.com/footprintid @footprintid"}],
  },
  {
    borderColor: "border-top-red",
    title: "Travel experts share their predictions for 2023’s best bets",
    description: "They are over buying big TV's and Peloton and want to ‘live,’'Beth Tofel, president of FootprintID, added. “As well as with remote work people can work from anywhere. So they can travel and work simultaneously.'",
    link: "https://www.consumeraffairs.com/news/travel-experts-share-their-predictions-for-2023s-best-bets-012323.html",
  },
  ];
  
  return (
    <div>
      <div className="services-sections">
        <h4 className="services-section-title"><span>Services</span> Overview</h4>
        <Typography
          variant="body1"
          sx={{
            color: '#34495e',
            fontSize: '20px',
            lineHeight: 1.8,
            fontWeight: 300,
            textAlign: 'justify',
            maxWidth: '1650px',
            margin: '0 auto'
          }}
        >
          Footprint ID® members, their loved ones or medical personnel will be
          able to access that person's medical information via the web,
          smartphone app or by calling our live representatives who are
          available 24 hours a day. Knowing that critical health information is
          available can help save lives in an emergency, provide medical history
          in times of stress, and gives each member invaluable peace of mind.
        </Typography>
      </div>
      
      <div className="services-overview-card">
        <Grid container spacing={{ xs: 7, sm: 8, md: 10, lg: 10, xl: 10}}>
          {lastestServices.map((service, index) => (
            <Grid
              key={index}
              item
              lg={3}
              md={6}
              sm={6}
              xs={12}
              
            >
              <div 
                className="service-item"
                style={{
                  position: 'relative',
                  cursor: 'pointer',
                  height: '100%'
                }}
              >
                {/* Colorful irregular background shape */}
                <div
                  style={{
                    position: 'absolute',
                    top: '0px',
                    right: '8px',
                    bottom: '2px',
                    left: '4px',
                    background: service.bgColor,
                    borderRadius: '30px',
                    zIndex: 0,
                    transform: 'rotate(352deg)',
                    opacity: '0.9'
                  }}
                />
                
                {/* White card body */}
                <div
                  style={{
                    background: 'white',
                    borderRadius: '20px',
                    padding: '40px 30px',
                    textAlign: 'center',
                    height: '100%',
                    transition: 'all 0.3s ease',
                    border: 'none',
                    boxShadow: '0 8px 25px rgba(0, 0, 0, 0.1)',
                    position: 'relative',
                    zIndex: 1
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = 'translateY(-8px)';
                    e.currentTarget.style.boxShadow = '0 15px 40px rgba(0, 0, 0, 0.15)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 8px 25px rgba(0, 0, 0, 0.1)';
                  }}
                >
                  {/* Title */}
                  <h6 
                    className={`service-item-block ${service.colorClass} text-center`}
                    style={{
                      fontSize: '22px',
                      fontWeight: '700',
                      marginBottom: '20px',
                      margin: '0 0 20px 0',
                      lineHeight: '1.2',
                      color: '#333'
                    }}
                  >
                    {service.title}
                  </h6>
                  
                  {/* Description */}
                  <p
                    style={{
                      fontSize: '15px',
                      color: '#666',
                      lineHeight: '1.6',
                      margin: '0 0 30px 0',
                      fontWeight: '400'
                    }}
                  >
                    {service.description}
                  </p>
                  
                  {/* Icon at bottom */}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center'
                    }}
                  >
                    <div
                      style={{
                        background: service.bgColor,
                        borderRadius: '16px',
                        padding: '20px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        width: '70px',
                        height: '70px',
                        boxShadow: '0 4px 15px rgba(0, 0, 0, 0.1)'
                      }}
                    >
                      <img
                        src={service.icon}
                        className="img-fluid"
                        alt={`${service.title} icon`}
                        style={{ 
                          maxWidth: '35px', 
                          height: 'auto',
                          filter: 'brightness(0) invert(1)' // Make icons white
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      </div>

      <div className="latest-news-sections">
        <h6 className="latest-news-title"><span>Latest</span> News</h6>
          <div className="latest-news-card">
              {latestItems.map((item, index) => (
                <div
                  key={index}
                  className={`${item.bg} col-lg-3 latest-news-card-inner`}
                  onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-10px)")}
                  onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                >
                  {/* First image */}
                  <div className="latest-card">
                    <img
                      src={item.images[0]}
                      className="img-fluid"
                      alt={`news-${index}`}
                    />
                  </div>

                  {/* Conditionally render second image or paragraph */}
                  {item.condition === "even" && item.images[1] && (
                    <div className="latest-card">
                      <img
                        src={item.images[1]}
                        className="img-fluid"
                        alt={`sub-${index}`}
                      />
                    </div>
                  )}

                  {item.condition === "odd" && item.text && (
                    <p className="latest-news-card-label">{item.text}</p>
                  )}

                  {/* Button */}
                  <div className="latest-button">
                    <button className="read-more-button">Read More</button>
                  </div>
                </div>
              ))}
          </div>
        <div className="article-main-sections latest-article">
          <div className="article-inner-sections">
            {articleItems.map((item, index) => (
              <div key={index} className={`article-inner-block ${item.borderColor}`}>
                <div>
                  <h2 className="article-inner-title">{item.title}</h2>
                  <p className="article-inner-description">{item.description}</p>
                </div>
                {item.cardLink && (
                  <div className="article-inner-link">
                    {item.cardLink.map((link, index) => (
                    <>
                    <a key={index} href={link.link} target="_blank" rel="noreferrer">
                        {link.text}
                      </a>
                      <br />
                    </>
                    ))}
                  </div>
                )}
                    <div className="article-inner-btn">
                  <a href={item.link} target="_blank" rel="noreferrer">
                    <button className="btn" type="button">
                      Read More
                    </button>
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="latest-get-date text-center">
          <p>Read to get started?</p>
          <div>
            <Link target="_self" to={"/contactus"}>
              <button
                className="btn-deep-orange"
                style={{ padding: "15px 50px" }}
              >
                Schedule a Demo
              </button>
            </Link>
          </div>
        </div>
      </div>

    </div>
  );
}
